module.exports = __webpack_public_path__ + "img/1526065671.805a7f03.jpg";